import { createSlice } from '@reduxjs/toolkit';


export const quickQuoteRate = createSlice({
  name: 'getCarrierRates',
  initialState: {
    QuickQuoteRateValues: {}
  },
  reducers: {
    setQuickQuoteRateValues: (state, action) => {
      return action.payload;
    }
  },
  extraReducers: {
    // Extra reducer comes here
  }
});
export const quickQuoteTLRate = createSlice({
  name: 'quickQuoteTLRate',
  initialState: {
    QuickQuoteTLRateValues: {}
  },
  reducers: {
    setQuickQuoteTLRateValues: (state, action) => {
      return action.payload;
    }
  },
  extraReducers: {
    // Extra reducer comes here
  }
});
export const quickQuoteSelectLoc = createSlice({
  name: 'quickQuoteLoc',
  initialState: {
    QuickQuoteRateLoc: ''
  },
  reducers: {
    setQuickQuoteRateLoc: (state, action) => {
      state.QuickQuoteRateLoc = action.payload;
    }
  },
  extraReducers: builder => {
    // Extra reducers can be added here if needed
  }
});
export const quickQuotePickupInfo = createSlice({
  name: 'quickQuotePickupInfo',
  initialState: {
    originCompanyName: '',
    originStreetAddress: '',
    originContactName: '',
    originContactPhone: '',
    originContactEmail: '',
    destinationCompanyName: '',
    destinationStreetAddress: '',
    destinationContactName: '',
    destinationContactPhone: '',
    destinationContactEmail: '',
    originOpenTime: '',
    originCloseTime: '',
    deliveryOpenTime: '',
    deliveryCloseTime: '',
    pickupInstructions: '',
    deliveryInstructions: '',
  },
  reducers: {
    setQuickQuotePickupInfo: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearQuickQuotePickupInfo: () => ({
      originCompanyName: '',
      originStreetAddress: '',
      originContactName: '',
      originContactPhone: '',
      originContactEmail: '',
      destinationCompanyName: '',
      destinationStreetAddress: '',
      destinationContactName: '',
      destinationContactPhone: '',
      destinationContactEmail: '',
      originOpenTime: '',
      originCloseTime: '',
      deliveryOpenTime: '',
      deliveryCloseTime: '',
      pickupInstructions: '',
      deliveryInstructions: '',
    })
  }
});

export const { setQuickQuoteRateLoc } = quickQuoteSelectLoc.actions;
export const { setQuickQuoteRateValues } = quickQuoteRate.actions;
export const { setQuickQuoteTLRateValues } = quickQuoteTLRate.actions;
export const { setQuickQuotePickupInfo, clearQuickQuotePickupInfo } = quickQuotePickupInfo.actions;
